export default "__VITE_ASSET__BxKJrGFr__"